/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Generate_Keynamerequired4Inputs */

const en_settings_reportingapikeys_generate_keynamerequired4 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Keynamerequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key name is required (1-255 characters).`)
};

/**
* | output |
* | --- |
* | "Key name is required (1-255 characters)." |
*
* @param {Settings_Reportingapikeys_Generate_Keynamerequired4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_keynamerequired4 = /** @type {((inputs?: Settings_Reportingapikeys_Generate_Keynamerequired4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Keynamerequired4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_keynamerequired4(inputs)
});
export { settings_reportingapikeys_generate_keynamerequired4 as "settings_reportingApiKeys_generate_keyNameRequired" }